import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class CountByDeviceBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const countByDevice = answersReport ? answersReport.countByDevice : [];

    const categories = countByDevice.map(item => item.device);
    const data = countByDevice.map(item => item.count);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: null,
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          return intl.formatMessage({id: 'numberOfAnswers'}, {count: this.y});
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            formatter: function() {
              return intl.formatMessage({id: 'numberOfAnswers'}, {count: this.y});
            },
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(CountByDeviceBarChart),
  graphql`
    fragment CountByDeviceBarChart_answersReport on AnswersReport {
      countByDevice {
        device
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CountByDeviceBarChart/CountByDeviceBarChart.js